var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsatransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "#705AE2",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7969 27.6723C52.7969 29.4839 52.6052 31.1308 52.2602 32.6263C49.115 18.9524 33.184 17.7608 33.184 17.7608H23.377V22.5912L9.20312 12.8698L23.377 3.14844V7.8493H33.184C33.184 7.8493 52.7969 9.31695 52.7969 27.6723ZM9.20312 34.3277C9.20312 32.5161 9.39482 30.8692 9.73981 29.3737C12.885 43.0476 28.816 44.2392 28.816 44.2392H38.623V39.4087L52.7969 49.1302L38.623 58.8516V54.1507H28.816C28.816 54.1507 9.20312 52.683 9.20312 34.3277Z",
    fill: "#E2CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 7.8493V17.7608H23.3771V22.5912L9.20312 12.8698L23.3771 3.14844V7.8493H31Z",
    fill: "#C1A6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 44.2391V54.1507H28.8155C28.8155 54.1507 9.20312 52.683 9.20312 34.3276C9.20312 32.516 9.39445 30.8692 9.73957 29.3737C12.8856 43.0476 28.8155 44.2391 28.8155 44.2391H31Z",
    fill: "#C1A6F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsatransfer);
export default __webpack_public_path__ + "static/media/asatransfer.b5c039536da933bad282b53485a403c4.svg";
export { ForwardRef as ReactComponent };